import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import AccountOnboardingButton from 'modules/banking/components/AccountOnboarding/Button'
import { LegalEntityOption } from 'modules/expenses/lib/types'

interface LegalEntityAccountCreationModalProps {
  legalEntity: LegalEntityOption
}

const LegalEntityAccountCreationModal = ({ legalEntity }: LegalEntityAccountCreationModalProps) => {
  return (
    <Modal
      title={i18n.t('expenses_v2.cards.actions.modal.create_account_for_legal_entity.title', {
        legal_entity_name: legalEntity?.legalName,
      })}
      illustration="credit-card"
      footer={
        <AccountOnboardingButton
          label={i18n.t('expenses_v2.cards.blocks.require_onboarding.create_account')}
          source={'expenses'}
          legalEntityId={legalEntity.id}
          trackingEvent={trackingEvents.expenses.goToCreateNonMainLegalEntityCardsAccount}
        ></AccountOnboardingButton>
      }
    >
      <Box flexDirection="column" justifyContent="flexStart" alignItems="flexStart" gap="s12">
        <Text.Normal color="grey800">
          {i18n.tView(
            'expenses_v2.cards.actions.modal.create_account_for_legal_entity.description',
            {
              legal_entity_name: (
                <Text.Normal weight="medium">{legalEntity?.legalName}</Text.Normal>
              ),
            }
          )}
        </Text.Normal>
      </Box>
    </Modal>
  )
}

export default LegalEntityAccountCreationModal
